export { default } from './blanket';
export type { BlanketProps } from './types';
